import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

import { Observable } from 'rxjs';
import { Licenciador } from '../interface/licenciador';

@Injectable({
    providedIn: 'root'
})
export class LicenciadorService {
    endPointLicenciadorCompleted: string = environment.apiGatewayUrl + '/api' + environment.endPointLicenciador;

    constructor(private http: HttpClient) {}

    save(licenciador: Licenciador) : Observable<Licenciador> {
        return this.http.post<Licenciador>(this.endPointLicenciadorCompleted + '/informarLicenca', licenciador);
    }

    validarLicenca(): Observable<Licenciador> {
        return this.http.get<Licenciador>(this.endPointLicenciadorCompleted + '/validarLicenca');
    }

    validarValidade(): Observable<Date> {
        return this.http.get<Date>(this.endPointLicenciadorCompleted + '/validarValidade');
    }

    validaCadNovo(): Observable<boolean>{
        return this.http.get<boolean>(this.endPointLicenciadorCompleted + "/validarCadNovosUsuarios");
      }
}